import React from "react"
import { Redirect } from "react-router-dom"

const NoMatch = ({client}) => (
	<Redirect to={client ? "/" : "/login"} />
)

export default NoMatch